export default () => ({
  interval: null,
  isSearch: false,
  invite: {
    document: null,
    state: null,
    name: null,
    email: null
  },
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/data.js